module.exports = __webpack_public_path__ + "44aebad1f2f80a5fa8222e433cd449b4.jpg";